import { getApiBaseUrl, readApiJson } from "./apiBase";
import { setAuthToken } from "./tokenHeaders";

export async function syncPaymentWithServer() {
  const response = await fetch(`${getApiBaseUrl()}/payment/sync`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: setAuthToken(),
    },
    body: JSON.stringify({}),
  });

  return readApiJson(response);
}
